import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initAttachmentsFormMany');
    $('#attachments').on('cocoon:before-insert', function (e, image) {
      $(image).css('display', 'block');
      $(image).fadeIn('slow');
      image.find(".attachment_attributes_uri").on('change', (e2: any) => {
        const input = e2.currentTarget as HTMLInputElement;
        readURL(input);
      });
    }).on('cocoon:before-remove', function (e, image) {
      $(this).data('remove-timeout', 1000);
      image.hide('slow');
    });

    $(".attachment_attributes_uri").on("change", (e) => {
      const input = e.currentTarget as HTMLInputElement;
      readURL(input);
    });

    function readURL(input: HTMLInputElement) {
      console.log('CHANGE');
      if (input.files && input.files[0]) {
        console.log(input.files[0].name);
        $(input).parent().parent().parent().find('.selected-file').val(input.files[0].name);
        $(input).parent().parent().parent().find('.selected-file-view').show(300);
      }
    }
  }
}